import { Controller } from "@hotwired/stimulus";
import { getJSON } from "../api.js";

// Badge salda portfela w nav (brutto łącznie; tooltip ze splitem wpłacone/bonus).
// Błąd API → badge zostaje ukryty (nawigacja nie może się wywalić).
// API sends "184.50"; the client sees Polish money format like everywhere else ("184,50").
const pln = (value) =>
  Number(value).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default class extends Controller {
  static values = {
    url: String, // /api/wallet/balance/
  };

  async connect() {
    let data;
    try {
      data = await getJSON(this.urlValue);
    } catch {
      this.element.hidden = true;
      return;
    }
    this.element.textContent = `${pln(data.total_available_gross_pln)} zł`;
    this.element.title = `Wpłacone: ${pln(data.deposited_pln)} zł · Bonus: ${pln(data.bonus_pln)} zł`;
    this.element.hidden = false;
  }
}
